import sso from "./sso";

export default {
  sso,
};
